import * as Yup from 'yup'

export default Yup.object().shape({
  feature: Yup.string().required('Required.')
})
